import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { class: "div-validation" }
const _hoisted_2 = {
  key: 0,
  class: "parent-chat-tab"
}
const _hoisted_3 = { class: "back-navigation-p cursor-pointer" }
const _hoisted_4 = { class: "display-flex justify-content-center" }
const _hoisted_5 = { class: "chat-detail-body" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "margin-left-10 width100" }
const _hoisted_8 = {
  key: 0,
  class: "chat-detail-body-availablefor"
}
const _hoisted_9 = {
  key: 1,
  class: "chat-detail-body-availablefor"
}
const _hoisted_10 = { class: "font-size-16" }
const _hoisted_11 = {
  id: "dvAutoJoinChannel",
  class: "display-flex"
}
const _hoisted_12 = { class: "description" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  id: "dvAutoJoinChannel",
  class: "display-flex"
}
const _hoisted_15 = { class: "description" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 2,
  class: "chat-detail-body-availablefor"
}
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "footer-tab" }
const _hoisted_20 = { class: "parent-div-buttons" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 1,
  class: "event-setting-addicon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValidationSummary = _resolveComponent("ValidationSummary")!
  const _component_ListOfParticipantGroups = _resolveComponent("ListOfParticipantGroups")!
  const _component_ImageProcess = _resolveComponent("ImageProcess")!

  return (_openBlock(), _createElementBlock("div", {
    class: "border-radius-20",
    onKeypress: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.isDirtyObject && _ctx.isDirtyObject(...args))),
    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.isDirtyObject && _ctx.isDirtyObject(...args))),
    onMousemove: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.isDirtyObject && _ctx.isDirtyObject(...args))),
    onTouchstart: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.isDirtyObject && _ctx.isDirtyObject(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isValidationSummaryVisible && !_ctx.showImageProcess)
        ? (_openBlock(), _createBlock(_component_ValidationSummary, {
            key: 0,
            "error-fields": _ctx.validationErrorFields,
            onCloseClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.CloseValidationSummary($event)))
          }, null, 8, ["error-fields"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.showImageProcess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.showImageProcess)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "back-navigation-div",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.BackNavigation()))
              }, [
                _cache[12] || (_cache[12] = _createElementVNode("i", {
                  class: "fa fa-arrow-left back-navigation-i cursor-pointer",
                  "aria-hidden": "true"
                }, null, -1)),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("EventSetting.CustomTheme.BackNavigation")), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "img-select chat-icon-img",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ClickOnImage(true)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.GetImageUrl(),
                  class: "iconImg round-image"
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t("EventSetting.Chat.ChannelName")), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.localChat.Name.$model) = $event)),
                      type: "text",
                      class: _normalizeClass(["form-control", _ctx.status(_ctx.v$.localChat.Name)]),
                      maxlength: 120
                    }, null, 2), [
                      [_vModelText, _ctx.v$.localChat.Name.$model]
                    ])
                  ])
                ]),
                (_ctx.showParticipantGroups && _ctx.ShowChatChannelCustomizeSection())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_ListOfParticipantGroups, {
                        "participant-groups": _ctx.localParticipantGroup,
                        "sub-heading": _ctx.subHeadingString,
                        "sub-module-type": _ctx.selectedSubModuleType.Chat,
                        onSendListOfParticipantGroupsIneditpane: _ctx.SetListParticipantGroups
                      }, null, 8, ["participant-groups", "sub-heading", "sub-module-type", "onSendListOfParticipantGroupsIneditpane"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.ShowChatChannelCustomizeSection())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("EventSetting.Chat.ParticipantJoinBehavior")), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localChat.Details.IsAutoJoin) = $event)),
                            class: "radio-btn",
                            type: "radio",
                            name: "autoJoinChannel",
                            value: false,
                            disabled: !_ctx.IsDisableCheckBox()
                          }, null, 8, _hoisted_13), [
                            [_vModelRadio, _ctx.localChat.Details.IsAutoJoin]
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(["margin-left-5 font-weight-bold", {'color-darkgray': !_ctx.IsDisableCheckBox()}])
                          }, _toDisplayString(_ctx.$t("EventSetting.Chat.RequireParticipantsToJoinManually")), 3)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localChat.Details.IsAutoJoin) = $event)),
                            class: "radio-btn",
                            type: "radio",
                            name: "autoJoinChannel",
                            value: true,
                            disabled: !_ctx.IsDisableCheckBox()
                          }, null, 8, _hoisted_16), [
                            [_vModelRadio, _ctx.localChat.Details.IsAutoJoin]
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(["margin-left-5 font-weight-bold", {'color-darkgray': !_ctx.IsDisableCheckBox()}])
                          }, _toDisplayString(_ctx.$t("EventSetting.Chat.AutomaticallyAddParticipantsToTheChannel")), 3)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.ShowChatChannelCustomizeSection())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("label", {
                        class: "lbl-chat-note",
                        innerHTML: _ctx.$t('EventSetting.Chat.Note')
                      }, null, 8, _hoisted_18)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "display-flex" }, [
              _createElementVNode("div", { class: "width100" }, [
                _createElementVNode("hr", { class: "footer-hr" })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: "btn btn-secondary btn-size-default btn-cancelevent",
                  disabled: !_ctx.isObjectDirty,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.Discard(_ctx.v$)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("Button.Discard")), 1)
                ], 8, _hoisted_21)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("button", {
                  class: "btn btn-primary btn-size-default width100 btn-create-event",
                  disabled: !_ctx.isObjectDirty,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.Submit()))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("Button.Save")), 1)
                ], 8, _hoisted_23)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showImageProcess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(_component_ImageProcess, {
            "image-src": _ctx.GetImageUrl(),
            "image-full-src": _ctx.GetImageFullUrl(),
            "heading-title": _ctx.$t('ImageProcess.iconImage'),
            "has-featured-image": false,
            "is-full-image": false,
            "module-name": _ctx.EventModule,
            "sub-module-name": _ctx.subModuleName,
            onSetImageIconUrl: _ctx.SetImageIconUrl,
            onSelectBack: _ctx.ClickOnImage
          }, null, 8, ["image-src", "image-full-src", "heading-title", "module-name", "sub-module-name", "onSetImageIconUrl", "onSelectBack"])
        ]))
      : _createCommentVNode("", true)
  ], 32))
}